import React from 'react';
import PropTypes from 'prop-types';
import { allowedMessageProps } from '../../lists/SystemMessages';
import { allowedTextAreaResizingOptions } from './_allowedPropTypes';
import { manageEventListener } from '../../../common/utils';

const resizeOnOverflow = function ({ target }) {
  const offset = target.offsetHeight - target.clientHeight;
  target.style.height = 'auto'; // eslint-disable-line no-param-reassign
  target.style.height = `${target.scrollHeight + offset}px`; // eslint-disable-line no-param-reassign
};

class InputFieldTextArea extends React.Component {
  constructor() {
    super();
    this.manageEventListeners = this.manageEventListeners.bind(this);
    this.refTextArea = React.createRef();
  }

  componentDidMount() {
    this.manageEventListeners('add');
  }

  componentWillUnmount() {
    this.manageEventListeners('remove');
  }

  manageEventListeners(action) {
    const {
      refTextArea: {
        current: textAreaElement
      }
    } = this;

    manageEventListener(textAreaElement, 'input', action, resizeOnOverflow);
  }

  render() {
    const {
      props: {
        inputAttributes,
        message,
        label,
        description,
        resizability,
        customChangeHandler
      },
      refTextArea
    } = this;

    const { className } = inputAttributes;
    const classNames = className ? className.split(' ') : [];

    if (resizability) {
      classNames.push(`resizable-${resizability}`);
    }

    const finalInputAttributes = {
      ...inputAttributes,
      ref: refTextArea,
      'aria-invalid': !!message
    };

    if (customChangeHandler) {
      finalInputAttributes.onChange = function ({ target: { value } }) {
        customChangeHandler({ value });
      };
    }

    if (classNames.length > 0) {
      finalInputAttributes.className = classNames.join(' ');
    }

    if (!label) {
      finalInputAttributes.title = description;
    }

    return <textarea {...finalInputAttributes} />;
  }
}

InputFieldTextArea.propTypes = {
  inputAttributes: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool
    ]).isRequired
  }).isRequired,
  label: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.bool
  ]),
  description: PropTypes.string.isRequired,
  message: PropTypes.shape(allowedMessageProps),
  resizability: PropTypes.oneOf(allowedTextAreaResizingOptions),
  customChangeHandler: PropTypes.func
};

export default InputFieldTextArea;